import { MultiListTable } from "./multiListTable";

export default MultiListTable;
